import ApplicationComponent from "legacy/ApplicationComponent"
import ErrorMessage from "legacy/ErrorMessage"
import SignInOrLogoutTitleSection from "legacy/auth/SignInOrLogoutTitleSection"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import SelectOrAddCard from "legacy/credit-cards/SelectOrAddCard"
import CustomerInformation from "legacy/payment-auth/CustomerInformation"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

// Note: jQuery is loaded globally, not via an import

class PaymentAuthController extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.state = {
      contact: {},
      termsAccepted: false,
      showingBoatDetails: false,
    }
    this.validator = validatorFactory({ autoForceUpdate: this })
    this.selectOrAddCardRef = React.createRef()
    this.cardSuccess = this.cardSuccess.bind(this)
    this.submit = this.submit.bind(this)
  }

  submit() {
    this.validator.showMessages()
    if (this.validator.allValid()) {
      this.selectOrAddCardRef.current.getCardAndType()
    }
  }

  cardSuccess(cardAndType) {
    this.setState({ processing: true })
    const params = {
      contact: this.state.contact,
    }
    if (cardAndType.type === "existing") {
      params.card_id = cardAndType.id
    } else {
      params.card_token = cardAndType.id
    }
    $.post($context.marinaCustomersPath, params, () => {
      window.location.href = $context.successRedirect
    }).fail(() => {
      this.setState({
        processing: false,
        errorMessage:
          "An error occurred while trying to save. Please contact support mayday@dockwa.com",
      })
    })
  }

  render() {
    this.validator.purgeFields()
    return (
      <div>
        <h3 className="font-semibold leading-normal">
          Please provide authorization for {this.props.marinaName} to charge
          your credit card for future payments.
        </h3>
        <SignInOrLogoutTitleSection
          currentUser={this.props.currentUser}
          contextTitle="contact information & payment details"
        />
        <hr />
        <div className="bs-mb-5">
          <CustomerInformation
            onChange={this.handleInputChange}
            validator={this.validator}
            contact={this.state.contact}
          />
          <hr />
          <h4 className="bs-mb-4 font-semibold">2. Payment Details</h4>
          <div style={{ maxWidth: "50rem" }}>
            <SelectOrAddCard
              ref={this.selectOrAddCardRef}
              userCards={[]}
              successCallback={this.cardSuccess}
            />
          </div>
          <hr />
          <h4 className="bs-mb-4 font-semibold">3. Submit</h4>
          <div className="checkbox">
            <label>
              <input
                type="checkbox"
                name="marinaTermsAccepted"
                checked={this.state.marinaTermsAccepted}
                onChange={this.handleInputChange}
              />
              I agree to {this.props.marinaName}{" "}
              <a
                href={$context.marinaTermsPath}
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms and Conditions
              </a>
              .
            </label>
          </div>
          {this.validator.message(
            "marinaTerms",
            this.state.marinaTermsAccepted,
            "accepted"
          )}
          <div className="checkbox">
            <label>
              <input
                type="checkbox"
                name="termsAccepted"
                checked={this.state.termsAccepted}
                onChange={this.handleInputChange}
              />
              I agree to Dockwa&apos;s{" "}
              <a
                href={$context.dockwaTermsPath}
                target="_blank"
                rel="noopener noreferrer"
              >
                Terms and Conditions
              </a>{" "}
              and{" "}
              <a
                href={$context.dockwaPrivacyPath}
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              .
            </label>
          </div>
          {this.validator.message(
            "dockwaTerms",
            this.state.termsAccepted,
            "accepted"
          )}
          <NextButton
            processing={this.state.processing}
            click={this.submit}
            icon=""
            btnClass="btn btn-primary mt-3"
            text="Submit Authorization"
            processingText="Submitting Authorization..."
          />
          {
            <ErrorMessage>
              {this.validator.messageWhenPresent(this.state.errorMessage)}
            </ErrorMessage>
          }
        </div>
      </div>
    )
  }
}

PaymentAuthController.propTypes = {
  marinaName: PropTypes.string.isRequired,
  currentUser: PropTypes.object,
}

export default PaymentAuthController
